export const GET_PAYMENTS = '[Payment Action] Get payments';
export const CONFIRMED_GET_PAYMENTS = '[Payment Action] Confirmed Get payments';
